module.exports = __webpack_public_path__ + "images/store_case_study/cowcowbookland-pic2_db3e1c5f2041aeb3d3eadb4a5db025e9.jpg";